module.exports = __webpack_public_path__ + "static/media/logo-dark.279ecae1.svg";